import React from 'react';
import AskTheExpertProvider from 'components/AskTheExpert';
import { routes } from 'constants/config';
import RenderInBody from 'components/shared/render_in_body';
import ModalContainer from 'components/shared/modal/modal_container';
import Form from './Form';
import SuccessMessage from './SuccessMessage';

const AskTheExpertModal = ({ onClose, expert, i18n }) => (
  <AskTheExpertProvider endpoint={routes.LEARN_ASK_THE_EXPERT}>
    {({
      submitQuestion,
      question,
      requestSending,
      updateQuestion,
      requestSent,
    }) => (
      <RenderInBody>
        <ModalContainer className="Modal ExpertPopout" onEscape={onClose}>
          {!requestSent && (
            <Form
              {...{
                expert,
                loading: requestSending,
                onClose,
                onSubmit: submitQuestion,
                question,
                updateQuestion,
                i18n: i18n.form,
              }}
            />
          )}
          {requestSent && (
            <SuccessMessage onClose={onClose} i18n={i18n.successMessage} />
          )}
          <div className="Modal-background" />
        </ModalContainer>
      </RenderInBody>
    )}
  </AskTheExpertProvider>
);

export default AskTheExpertModal;
